export const INVITE_RESENT = 'INVITE_RESENT';
export const INVITED_CAREGIVER = 'INVITED_CAREGIVER';
export const LOADED_CONNECTIONS = 'LOADED_CONNECTIONS';
export const LOADED_PENDING_CONNECTIONS = 'LOADED_PENDING_CONNECTIONS';
export const REMOVE_CONNECTION = 'REMOVE_CONNECTION';
export const REMOVE_PENDING_CONNECTION = 'REMOVE_PENDING_CONNECTION';

export interface LLUState {
  connections: LLUConnection[];
  pending: Invitation[];
  recentlyDeclined: string[];
  recentlyInvited: string[];
}

interface InviteResentAction {
  type: typeof INVITE_RESENT;
  inviteId: string;
}

interface InvitedCaregiverAction {
  type: typeof INVITED_CAREGIVER;
  invitation: Invitation;
}

interface LoadedConnectionsAction {
  type: typeof LOADED_CONNECTIONS;
  connections: LLUConnection[];
}

interface LoadedPendingConnectionsAction {
  type: typeof LOADED_PENDING_CONNECTIONS;
  pending: Invitation[];
}

interface RemoveConnectionAction {
  type: typeof REMOVE_CONNECTION;
  connectionId: string;
}
interface RemovePendingConnectionAction {
  type: typeof REMOVE_PENDING_CONNECTION;
  invitationId: string;
}

export type LLUActions =
  | InviteResentAction
  | InvitedCaregiverAction
  | LoadedConnectionsAction
  | LoadedPendingConnectionsAction
  | RemoveConnectionAction
  | RemovePendingConnectionAction;
